import { IUnitResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import { queryClient } from 'utils/query';

export function ensureUnits() {
    return queryClient.ensureQueryData<IUnitResponse[]>({
        queryKey: ['units'],
        queryFn: async () => {
            const responses: IUnitResponse[] = [];
            const firstResponse = await sdClient.getUnits({
                page: 1,
                pageLimit: 100,
            });

            responses.push(...firstResponse.Result);

            const totalPages = firstResponse.TotalPages;
            if (totalPages > 1) {
                const promises = [];
                for (let i = 2; i <= totalPages; i++) {
                    promises.push(
                        sdClient.getUnits({
                            page: i,
                            pageLimit: 100,
                        }),
                    );
                }
                const remainingResponses = await Promise.all(promises);
                responses.push(...remainingResponses.flatMap((r) => r.Result));
            }
            return responses;
        },
    });
}
